import {useEffect} from 'react';
import {BrowserRouter, Route, Routes} from "react-router";
import {Amplify} from 'aws-amplify'
import {Authenticator, ThemeProvider, useTheme, View} from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import outputs from "./amplify_outputs.json";
import {appTheme} from "./appTheme";
import {EditPage, MainPage, NavBar} from "./my-components";

Amplify.configure(outputs);

const App = () => {
    const {tokens} = useTheme();

    useEffect(() => {
        if ('Notification' in window && Notification.permission === 'default') {
            Notification.requestPermission();
        }
    }, []);

    return (
        <Authenticator socialProviders={['google']} variation={"modal"} hideSignUp={true}>
            {({signOut, user}) => (
                <ThemeProvider theme={appTheme}>
                    <View maxWidth="500px"
                          margin="0 auto"
                          minHeight="100vh"
                          padding={tokens.space.small}
                          backgroundColor={tokens.colors.background.primary}
                    >
                        <BrowserRouter>
                            <NavBar user={user} signOut={signOut}/>
                            <main>
                                <Routes>
                                    <Route path="/" element={<MainPage/>}/>
                                    <Route path="/edit" element={<EditPage/>}/>
                                </Routes>
                            </main>
                        </BrowserRouter>
                    </View>
                </ThemeProvider>
            )}
        </Authenticator>
    )
}
export default App
